import { cva } from "class-variance-authority";

export const inputVariants = cva(
  [
    "rounded-lg border border-neutral-80 bg-white text-center font-semibold tracking-[2%] text-primary-50 placeholder:text-neutral-80",
    "focus:border-primary-80 focus:shadow-input focus-visible:ring-transparent focus-visible:outline-hidden",
    "disabled:cursor-not-allowed disabled:border-neutral-80 disabled:bg-neutral-95 disabled:text-neutral-50",
  ],
  {
    variants: {
      size: {
        sm: "h-10 w-10 min-w-10 text-2xl sm:h-16 sm:w-16 sm:min-w-16 sm:text-[2.5rem]",
        md: "h-16 w-16 min-w-16 text-[2.5rem] sm:h-20 sm:w-20 sm:min-w-20 sm:text-5xl",
        lg: "h-20 w-20 min-w-20 text-5xl sm:h-24 sm:w-24 sm:min-w-24 sm:text-[3.5rem]",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  }
);
